import { Link } from "react-router-dom";

const stats = [
  { value: "1,286", label: "在聊话题" },
  { value: "8.4万", label: "今日新增讨论" },
  { value: "1,320", label: "此刻在线网友" },
];

export default function Hero() {
  return (
    <section className="relative w-full min-h-[560px] md:min-h-[620px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=stylized%20artistic%20illustration%20of%20a%20lively%20crowd%20of%20colorful%20speech%20bubbles%20rising%20over%20a%20warm%20amber%20and%20terracotta%20landscape%2C%20abstract%20geometric%20shapes%2C%20subtle%20grain%20texture%2C%20cinematic%20glow%2C%20minimalist%20editorial%20poster%20style&width=1800&height=1000&seq=gossip-hero-main&orientation=landscape"
          alt="17吃瓜社区 - 网友在线讨论娱乐话题的抽象插画"
          title="17吃瓜社区 娱乐话题讨论"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-primary-950/70 via-primary-950/55 to-primary-950/75"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-10 py-24 text-center">
        <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-background-50/15 text-background-50 text-xs md:text-sm mb-6 backdrop-blur">
          <i className="ri-live-line text-accent-300"></i>
          热门话题实时滚动 · 边看边聊
        </span>
        <h1 className="font-heading font-black text-background-50 text-3xl sm:text-4xl md:text-6xl leading-tight">
          17吃瓜社区
        </h1>
        <p className="mt-5 text-background-100 text-base md:text-xl max-w-3xl mx-auto leading-relaxed">
          热门话题在这里实时滚动,网友边看边聊。同一个事件,你会看到很多种不同的角度——这大概就是讨论最有意思的地方。
        </p>
        <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/topics"
            className="w-full sm:w-auto px-7 py-3 rounded-md bg-primary-500 text-background-50 text-sm md:text-base font-medium whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer flex items-center justify-center gap-2"
          >
            <i className="ri-chat-smile-2-line"></i>
            进话题广场看看
          </Link>
          <a
            href="#hot-topics"
            className="w-full sm:w-auto px-7 py-3 rounded-md bg-background-50/15 text-background-50 text-sm md:text-base font-medium whitespace-nowrap hover:bg-background-50/25 transition-colors cursor-pointer backdrop-blur flex items-center justify-center gap-2"
          >
            <i className="ri-fire-line text-accent-300"></i>
            先看今天的热帖
          </a>
        </div>

        <dl className="mt-12 grid grid-cols-3 gap-4 max-w-2xl mx-auto">
          {stats.map((s) => (
            <div key={s.label} className="text-center">
              <dt className="sr-only">{s.label}</dt>
              <dd className="font-heading font-bold text-background-50 text-xl md:text-3xl">{s.value}</dd>
              <dd className="text-background-100/80 text-xs md:text-sm mt-1">{s.label}</dd>
            </div>
          ))}
        </dl>
      </div>
    </section>
  );
}